import React, { useEffect, useState, memo } from 'react'
import { useIonPicker } from '@ionic/react'
import { localStore } from '@utils'
import BagIcon from 'components/element/BagIcon'
import './index.scss'

export interface ICartPackPickerProps {
  cnt: number;
  total: number;
  showTip?: boolean;
  onChange: (value: number) => void;
}

const CartPackPicker: React.FC<ICartPackPickerProps> = (props) => {
  const { cnt, total, showTip, onChange } = props
  const [present] = useIonPicker()

  const [packedCnt, setPackedCnt] = useState(cnt)

  const getPacks = () =>
    new Array(total)
      .fill('')
      .map((_item, index) => ({ text: `${index + 1}`, value: index + 1 }))

  const handleSelectPack = (cnt: number) => {
    cnt = cnt === packedCnt ? 0 : cnt
    setPackedCnt(cnt)
    onChange(cnt)
    if (!localStore.get('packed')) {
      localStore.set('packed', true, 3000)
    }
  }

  const handleShowPicker = () => {
    present({
      cssClass: 'mkt-picker',
      buttons: [
        {
          text: i18n.t('mkt.common.cancel'),
        },
        {
          text: i18n.t('mkt.common.confirm'),
          handler: (selected) => {
            handleSelectPack(selected.packnum.value)
          },
        },
      ],
      columns: [
        {
          name: 'packnum',
          selectedIndex: packedCnt - 1,
          options: getPacks(),
        },
      ],
    })
  }

  useEffect(() => {
    setPackedCnt(cnt)
  }, [cnt])

  return (
    <div className='cart-pack-wrapper'>
      <span className='cart-pack-process'>
        {i18n.t('menu.togo')}: {packedCnt}/{total}
      </span>
      <div className='cart-pack-selector'>
        {showTip && <div className='animated pack-tip'>👇</div>}
        {new Array(total > 6 ? 5 : total).fill('').map((_item, index) => (
          <BagIcon key={`pack_${index}`} onClick={() => handleSelectPack(index + 1)} status={packedCnt >= index + 1 ? 'fill' : 'empty'} />
        ))}
        {total > 6 && (
          <span className='more-pack' data-cypid='cartPackShowPicker' onClick={handleShowPicker}>
            ···
          </span>
        )}
      </div>
    </div>
  )
}

export default memo(CartPackPicker)
